import React from "react";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  useGetEnergyGraphQuery,
  useGetEnergyValuesQuery,
} from "./municipalityAPISlice";
import { useGetDeviceSwitchingGraphDataQuery, useGetTjommieGraphDataQuery } from "../api/apiSlice";
import DeviceSwitchingGraph from "./DeviceSwitchingGraph";
import TjommieDemandGraph from "./TjommieDemandGraph";
import DarkDateRangePicker from "../OperatorDashboard/DarkDateRangePicker";

export default function MunicipalityLandingPage({ title = "Home" }) {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [start_date, setstart_date] = React.useState(dayjs().subtract(30, "day"));
  const [end_date, setEnd_date] = React.useState(dayjs());

  const request = {
    start_date: start_date.format("YYYY-MM-DD"),
    end_date: end_date.format("YYYY-MM-DD"),
    user_timezone: userTimezone,
  };

  const { isSuccess: isSuccessEnergyGraph } = useGetEnergyGraphQuery(request);
  const { isSuccess: isSuccessDataValuesTextField } = useGetEnergyValuesQuery(request);
  const { data: device_switching_data, isSuccess: isDeviceSwitchingDataSuccess } = useGetDeviceSwitchingGraphDataQuery(request);
  const { data: tjommie_data, isSuccess: isTjommieSuccess } = useGetTjommieGraphDataQuery(request);

  if (isSuccessEnergyGraph && isSuccessDataValuesTextField && isDeviceSwitchingDataSuccess && isTjommieSuccess) {
    return (
      <Box sx={{ maxWidth: 1500, margin: "0 auto", padding: "80px 32px 48px", minHeight: "100vh", color: "#e0e6f0" }}>
        <Box sx={{ mb: "28px" }}>
          <Typography sx={{ fontSize: "1.7rem", fontWeight: 700, color: "#fff", letterSpacing: "-0.025em" }}>
            {title}
          </Typography>
        </Box>

        <Box sx={{ mb: "24px" }}>
          <DarkDateRangePicker
            compact
            startDate={start_date}
            endDate={end_date}
            onApply={(start, end) => { setstart_date(start); setEnd_date(end); }}
          />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <DeviceSwitchingGraph graph_data={device_switching_data} />
          <TjommieDemandGraph graph_data={tjommie_data} />
        </Box>
      </Box>
    );
  }

  return <></>;
}
